import React, { useEffect } from 'react';
import { refreshScrollAnimation } from '../utils/scrollAnimation';

const Footer = () => {
    useEffect(() => {
        // Refresh animations when Footer mounts
        refreshScrollAnimation();
    }, []);

    return (
        <>
        {/* <!-- Footer Start --> */}
        <footer className="footer-area style-one">
            <div className="footer-top position-relative z-1 bg-title round-20 pt-120">
                <div className="container style-one">
                    <div className="contact-info-box d-flex flex-wrap align-items-center round-15" data-aos="fade-up" data-aos-duration="1100" data-aos-delay="200">
                        <div className="contact-item d-flex flex-wrap align-items-center position-relative z-1">
                            <div className="contact-icon position-relative d-flex flex-column align-items-center justify-content-center rounded-circle bg_primary"><img src="/assets/img/icons/phone-icon-white.svg" alt="Icon"/></div>
                            <div className="contact-info">
                                <span className="d-block text-title lh-1">Emergency Line</span>
                                <a href="tel:123456789043" className="text-title link-hover-title fs-18 font-secondary fw-semibold">+1 (234) 567 890 43</a>
                            </div>
                        </div>
                        <div className="contact-item d-flex flex-wrap align-items-center position-relative z-1">
                            <div className="contact-icon position-relative d-flex flex-column align-items-center justify-content-center rounded-circle bg_primary"><img src="/assets/img/icons/mail-icon-white.svg" alt="Icon"/></div>
                            <div className="contact-info">
                                <span className="d-block text-title lh-1">Support Email</span>
                                <a href="mailto:[email protected]" className="text-title link-hover-title fs-18 font-secondary fw-semibold"><span className="__cf_email__" data-cfemail="a3d0d6d3d3ccd1d7e3cbcacdd7cccd8dc0ccce">[email&#160;protected]</span></a>
                            </div>
                        </div>
                        <div className="contact-item d-flex flex-wrap align-items-center position-relative z-1">
                            <div className="contact-icon position-relative d-flex flex-column align-items-center justify-content-center rounded-circle bg_primary"><img src="/assets/img/icons/pin-icon-white.svg" alt="Icon"/></div>
                            <div className="contact-info">
                                <span className="d-block text-title lh-1">Visit Us On</span>
                                <p className="d-inline-block text-title fs-18 font-secondary fw-semibold mb-0">245 14h Street, Torento, Canada</p>
                            </div>
                        </div>
                    </div>
                    <div className="row pt-120 pb-90">
                        <div className="col-xxl-3 col-xl-4 col-md-6 col-md-6 pe-xxl-4 pe-xl-4 pe-lg-5">
                            <div className="footer-widget mb-30" data-aos="fade-up" data-aos-duration="1100" data-aos-delay="300">
                                <a href="index.html" className="logo d-block mb-32">
                                    <img src="/assets/img/logo-white.png" alt="Logo"/>
                                </a>
                                <p className="comp-desc text-white fs-xx-14 mb-22">We strive to create a welcoming environment where patients feel valued respected and well informed about their health</p>
                                <div className="social-share d-flex align-items-center">
                                    <span className="text-white me-3 fs-xx-14">Follow Us:</span>
                                    <ul className="social-profile style-two list-unstyled mb-0">
                                        <li><a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" className="d-flex flex-column align-items-center justify-content-center rounded-circle"><i className="ri-facebook-fill"></i></a></li>
                                        <li><a href="https://x.com/?lang=en" target="_blank" rel="noopener noreferrer" className="d-flex flex-column align-items-center justify-content-center rounded-circle"><i className="ri-twitter-x-line"></i></a></li>
                                        <li><a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" className="d-flex flex-column align-items-center justify-content-center rounded-circle"><i className="ri-instagram-fill"></i></a></li>
                                        <li><a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" className="d-flex flex-column align-items-center justify-content-center rounded-circle"><i className="ri-linkedin-fill"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-2 offset-xxl-1 col-xl-2 col-md-6 col-md-3 ps-xl-4">
                            <div className="footer-widget mb-30" data-aos="fade-up" data-aos-duration="1100" data-aos-delay="400">
                                <h3 className="footer-widget-title fs-24 fw-extrabold text-white position-relative">Quick Links</h3>
                                <ul className="footer-menu list-unstyled mb-0">
                                    <li>
                                        <a href="hospitals-search.html" className="link">
                                            <span className="link-container">
                                                <span className="link-title1 title text-white">Medical Directory</span>
                                                <span className="link-title2 title text_secondary">Medical Directory</span>
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="doctors-list.html" className="link">
                                            <span className="link-container">
                                                <span className="link-title1 title text-white">Top Doctors</span>
                                                <span className="link-title2 title text_secondary">Top Doctors</span>
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="blog-left-sidebar.html" className="link">
                                            <span className="link-container">
                                                <span className="link-title1 title text-white">Latest News</span>
                                                <span className="link-title2 title text_secondary">Latest News</span>
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="about.html" className="link">
                                            <span className="link-container">
                                                <span className="link-title1 title text-white">Why Choose Us</span>
                                                <span className="link-title2 title text_secondary">Why Choose Us</span>
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="contact.html" className="link">
                                            <span className="link-container">
                                                <span className="link-title1 title text-white">Contact</span>
                                                <span className="link-title2 title text_secondary">Contact</span>
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-3 col-md-6 ps-xxl-57 ps-xl-5">
                            <div className="footer-widget mb-30" data-aos="fade-up" data-aos-duration="1100" data-aos-delay="500">
                                <h3 className="footer-widget-title fs-24 fw-extrabold text-white position-relative">Useful Links</h3>
                                <ul className="footer-menu list-unstyled mb-0">
                                    <li>
                                        <a href="hospitals-list.html" className="link">
                                            <span className="link-container">
                                                <span className="link-title1 title text-white">Featured Hospitals</span>
                                                <span className="link-title2 title text_secondary">Featured Hospitals</span>
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="about.html" className="link">
                                            <span className="link-container">
                                                <span className="link-title1 title text-white">How It Works</span>
                                                <span className="link-title2 title text_secondary">How It Works</span>
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="hospital-reviews-location-with-map.html" className="link">
                                            <span className="link-container">
                                                <span className="link-title1 title text-white">Find A Location</span>
                                                <span className="link-title2 title text_secondary">Find A Location</span>
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="doctors-search.html" className="link">
                                            <span className="link-container">
                                                <span className="link-title1 title text-white">Doctors Search</span>
                                                <span className="link-title2 title text_secondary">Doctors Search</span>
                                            </span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="online-consultation-telemedicine.html" className="link">
                                            <span className="link-container">
                                                <span className="link-title1 title text-white">Telemedicine Services</span>
                                                <span className="link-title2 title text_secondary">Telemedicine Services</span>
                                            </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6 ps-xxl-5 ps-xl-0">
                            <div className="footer-widget mb-30" data-aos="fade-up" data-aos-duration="1100" data-aos-delay="600">
                                <h3 className="footer-widget-title fs-24 fw-extrabold text-white position-relative">Subscribe Newsletter</h3>
                                <p className="text-white fs-xx-14 mb-22 pe-xxl-5">Sign up for our newsletter to latest weekly updates & news</p>
                                <form onSubmit={(e) => e.preventDefault()} className="newsletter-form d-flex flex-wrap">
                                    <input type="email" placeholder="Enter Your Email" className="round-10 fs-15 text-white outline-0"/>
                                     <button type="submit" className="border-0 round-10 transition">
                                        <img src="/assets/img/icons/plane.svg" alt="Icon" className="transition"/>
                                        </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="container style-one">
                    <div className="row">
                        <div className="col-md-6 mb-sm-10">
                            <p className="copyright-text mb-0 text-center text-md-start fs-xx-14" ><i className="ri-copyright-line"></i><span className="text_primary fw-semibold">Hinton</span> Is Proudly Owned By <a href="https://envytheme.com/" target="_blank" rel="noopener noreferrer" className="text_primary fw-semibold link-hover-primary">EnvyTheme</a></p>
                        </div>
                        <div className="col-md-6">
                            <ul className="footer-bottom-menu list-unstyled text-md-end text-center mb-0">
                                <li><a href="privacy-policy.html" className="text-para hover-text-primary link-hover-primary fs-xx-14">Privacy Policy</a></li>
                                <li><a href="terms-conditions.html" className="text-para hover-text-primary link-hover-primary fs-xx-14">Terms & Conditions</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        {/* <!-- Footer End --> */}

        {/* <!-- Back to Top --> */}
        <div id="progress-wrap" className="progress-wrap style-one">
            <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
              <path id="progress-path" d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"/>
            </svg>
        </div>
        </>
    );
};

export default Footer;
